import React from "react";
import PVReviewIndex from "../../sub-treasury/pv-collection/PVReviewIndex";

const MdaApprovePV = () => {
  return <PVReviewIndex mdaType="self-sustaining" mode="approve" />;
};
export default MdaApprovePV;
